import { useState } from "react";
import Swal from "sweetalert2";
import "./Contact.css";

function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    videoLink: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const phoneNumber = "923706799599"; 

    const text = `
🎬 *VIDEO EDITING REQUEST*

👤 Name: ${form.name}
📧 Email: ${form.email}

📌 Subject: ${form.subject || "Not specified"}

🎥 Reference Video:
${form.videoLink || "Not provided"}

📝 Editing Description:
${form.message}

──────────────────
📍 Sent from Portfolio Website
    `;

    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(text)}`;

    window.open(url, "_blank");

    Swal.fire({
      icon: "success",
      title: "Request Sent 🎉",
      text: "Your video editing request has been sent successfully!",
      confirmButtonColor: "#2563eb",
    });

    setForm({
      name: "",
      email: "",
      subject: "",
      videoLink: "",
      message: "",
    });
  };

  return (
    <section className="contact-section">
      <div className="contact-container">

        {/* LEFT SIDE */}
        <div className="contact-info">
          <span className="contact-tag">VIDEO EDITING SERVICE</span>
          <h1>Send Your Project</h1>

          <p>
            Share your reference video and explain how you want your video edited.
          </p>

          <div className="info-box">
            <h4>What you can send:</h4>
            <p>✔ YouTube / Drive link</p>
            <p>✔ Editing style (cinematic, reels, ads)</p>
            <p>✔ Your idea or script</p>
          </div>
        </div>

        {/* RIGHT FORM */}
        <form className="contact-form" onSubmit={handleSubmit}>

          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={form.name}
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={form.email}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="subject"
            placeholder="Project Title (Optional)"
            value={form.subject}
            onChange={handleChange}
          />

          <input
            type="text"
            name="videoLink"
            placeholder="Reference Video Link (YouTube / Drive)"
            value={form.videoLink}
            onChange={handleChange}
          />

          <textarea
            name="message"
            placeholder="Describe how you want the video to be edited..."
            rows="6"
            value={form.message}
            onChange={handleChange}
            required
          />

          <button type="submit">
            Send Request on WhatsApp
          </button>
        </form>

      </div>
    </section>
  );
}

export default Contact;